// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NtZO","clinicsSelect":"styles_clinicsSelect__16hyT"};